/**
 * 漫画项目
 */

import StoreDecorator, {
  Action,
  Mutation,
  Getter,
  AutoLoading
} from '@acgn/herm/lib/store-decorator';

import {
  getComicList,
  getProjectByStatus,
  userProlist,
  createComic,
  addProjectlink,
  updateComic,
  getProjectNum,
  getTemplate,
  getProjectDetail,
  searchCreateUser,
  delProject,
  recoverProject,
  getProjectListByName,
  addTemplateLink,
  delTemplateLink,
  sortTemplateLink
} from '../../api/comic';

interface StateType {
  comicList?: any; // 漫画项目列表
  userComicList?: any; // 成员项目列表，用于统计
}
@StoreDecorator
@AutoLoading
class StoreModule {
  public state() {
    return {
      comicList: {},
      userComicList: [] // 成员项目列表，用于统计
    };
  }

  // 查看成员参与项目
  @Action('setUserComicList')
  public async userProlist(state: StateType, payload: any) {
    return await userProlist(payload);
  }

  // 创建漫画项目
  @Action()
  public async createComic(state: StateType, payload: any) {
    return await createComic(payload);
  }

  // 添加项目的环节流程模板
  @Action()
  public async addProjectlink(state: StateType, payload: any) {
    return await addProjectlink(payload);
  }


  // 编辑漫画项目
  @Action()
  public async updateComic(state: StateType, payload: any) {
    return await updateComic(payload);
  }

  // 项目管理获取分状态的项目数量
  @Action()
  public async getProjectNum(state: StateType, payload: any) {
    return await getProjectNum(payload);
  }

  // 获取流程设置的模板
  @Action()
  public async getTemplate(state: StateType, options: any) {
    return await getTemplate(options);
  }

  // 获取项目详情
  @Action()
  public async getProjectDetail(state: StateType, options: any) {
    return await getProjectDetail(options);
  }
  // 获取项目详情
  @Action()
  public async searchCreateUser(state: StateType, options: any) {
    return await searchCreateUser(options);
  }

  // 删除项目
  @Action()
  public async delProject(state: StateType, options: any) {
    return await delProject(options);
  }

  // 删除项目
  @Action()
  public async recoverProject(state: StateType, options: any) {
    return await recoverProject(options);
  }

  // 获取项目详情
  @Action()
  public async getProjectByStatus(state: StateType, options: any) {
    return await getProjectByStatus(options);
  }

  // 根据关键词获取漫画项目列表(模糊搜索)
  @Action()
  public async getProjectListByName(state: StateType, options: any) {
    return await getProjectListByName(options);
  }

  // 添加环节
  @Action()
  public async addTemplateLink(state: StateType, options: any) {
    return await addTemplateLink(options);
  }

  // 删除环节
  @Action()
  public async delTemplateLink(state: StateType, options: any) {
    return await delTemplateLink(options);
  }

  // 排序环节
  @Action()
  public async sortTemplateLink(state: StateType, options: any) {
    return await sortTemplateLink(options);
  }

  // 获取漫画项目列表
  @Action('setComicList')
  public async getComicList({ commit, state }: any, option: any) {
    return await getComicList(option);
  }

  // 获取流程设置的模板
  @Mutation('comicList')
  public setComicList(state: StateType, payload: any) {
    return payload;
  }

  // 设置成员项目列表
  @Mutation('userComicList')
  public setUserComicList(state: StateType, payload: any) {
    return payload.result.items;
  }

  // 漫画项目列表
  @Getter
  public comicList(state: StateType) {
    return state.comicList;
  }

  // 成员项目列表
  @Getter
  public userComicList(state: StateType) {
    return state.userComicList;
  }
}

export default new StoreModule();
